<mat-sidenav-container class="sidenav-container">
    <!-- Side Navigation -->
    <mat-sidenav #sidenav mode="over" class="sidenav" [opened]="false" role="navigation">
        <mat-toolbar class="sidenav-header">
          <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/71ceeedb-5297-4289-b246-87e594f0ff00/public" class="logo" alt="logo">
        </mat-toolbar>
      
        <!-- DASHBOARD -->
        <div class="menu-category" (click)="toggleSection('dashboard')">
          <span>DASHBOARD</span>
          <mat-icon>{{ sections.dashboard ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <mat-nav-list class="menu-section" *ngIf="sections.dashboard" >
          <mat-list-item *ngFor="let menuItem of dashItems" class="menu-item" (click)="goToPage(menuItem.ref,sidenav)">
            <span mat-line>
              <i [class]="getCssClass(menuItem)"></i> {{ menuItem.section }}
            </span>
          </mat-list-item>
        </mat-nav-list>
      
        <!-- LIBRARY Y KB'S -->
        <div class="menu-category" (click)="toggleSection('library')">
          <span>LIBRARY Y KB'S</span>
          <mat-icon>{{ sections.library ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <mat-nav-list class="menu-section" *ngIf="sections.library">
          <mat-list-item *ngFor="let menuItem of menuKbs" class="menu-item" (click)="goToPage(menuItem.ref,sidenav)">
            <span mat-line>
              <i [class]="getCssClass(menuItem)"></i> {{ menuItem.section }}
            </span>
          </mat-list-item>
        </mat-nav-list>
      
        <!-- COMMUNICATIONS -->
        <div class="menu-category" (click)="toggleSection('communications')">
          <span>COMMUNICATIONS</span>
          <mat-icon>{{ sections.communications ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <mat-nav-list class="menu-section" *ngIf="sections.communications">
          <mat-list-item *ngFor="let menuItem of menuCommunication" class="menu-item" (click)="goToPage(menuItem.ref,sidenav)">
            <span mat-line>
              <i [class]="getCssClass(menuItem)"></i> {{ menuItem.section }}
            </span>
          </mat-list-item>
        </mat-nav-list>
      
        <!-- BUDGETS -->
        <div class="menu-category" (click)="toggleSection('budgets')">
          <span>BUDGETS</span>
          <mat-icon>{{ sections.budgets ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <mat-nav-list class="menu-section" *ngIf="sections.budgets">
          <mat-list-item *ngFor="let menuItem of menuBudgets" class="menu-item" (click)="goToPage(menuItem.ref,sidenav)">
            <span mat-line>
              <i [class]="getCssClass(menuItem)"></i> {{ menuItem.section }}
            </span>
          </mat-list-item>
        </mat-nav-list>

        <!-- STUDY -->
        <div class="menu-category" (click)="toggleSection('study')">
          <span>STUDY</span>
          <mat-icon>{{ sections.study ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <mat-nav-list class="menu-section" *ngIf="sections.study">
          <mat-list-item *ngFor="let menuItem of menuStudy" class="menu-item" (click)="goToPage(menuItem.ref,sidenav)">
            <span mat-line>
              <i [class]="getCssClass(menuItem)"></i> {{ menuItem.section }}
            </span>
          </mat-list-item>
        </mat-nav-list>
        

         <!-- WEBAPP -->
         <div class="menu-category" (click)="toggleSection('webapp')">
          <span>WEB APP</span>
          <mat-icon>{{ sections.webapp ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <mat-nav-list class="menu-section" *ngIf="sections.webapp">
          <mat-list-item *ngFor="let menuItem of webapp" class="menu-item" (click)="goToPage(menuItem.ref,sidenav)">
            <span mat-line>
              <i [class]="getCssClass(menuItem)"></i> {{ menuItem.section }}
            </span>
          </mat-list-item>
        </mat-nav-list>
      
        <!-- COLLABORATIONS -->
        <div class="menu-category" (click)="toggleSection('collaborations')">
          <span>COLLABORATIONS</span>
          <mat-icon>{{ sections.collaborations ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <mat-nav-list class="menu-section" *ngIf="sections.collaborations">
          <mat-list-item *ngFor="let menuItem of collabs" class="menu-item" (click)="goToPage(menuItem.ref,sidenav)">
            <span mat-line>
              <i [class]="getCssClass(menuItem)"></i> {{ menuItem.section }}
            </span>
          </mat-list-item>
        </mat-nav-list>
    </mat-sidenav>
      
    <!-- Main Content -->
    <mat-sidenav-content>
      <mat-toolbar color="primary" class="toolbar" *ngIf="isToolBarVisible()">
        <!-- USER APP HEADER MENU -->
        <button mat-icon-button (click)="sidenav.toggle()" aria-label="Toggle sidenav">
          <mat-icon>menu</mat-icon>
        </button>

        <div class="toolbar-title">
					<div class="responsive-logo">
						<a href="javascript: void(0)" (click)="goToHome()">
              <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/e2398d78-f4e9-43b9-77c7-c58737e15f00/public" class="mobile-logo" alt="logo">
            </a>
					</div>
				</div>

        <div>
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example"> <!-- *ngIf="visibleDotsMenu" -->
            <mat-icon class="margin-sides-1rem icon-gray">more_vert</mat-icon>
          </button>
          
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="closeSession()">
              <mat-icon>power_settings_new</mat-icon>
              <span>Cerrar sesión</span>
            </button>

            <button mat-menu-item aria-label="User options" (click)="goTo('settings')">
              <mat-icon>account_circle</mat-icon>
              <span>User setting</span>
            </button>
          </mat-menu>

        </div>
        
      </mat-toolbar>
  
      <!-- Page Content -->
      <div>
        <router-outlet></router-outlet>
      </div>
      
    </mat-sidenav-content>
  </mat-sidenav-container>
